import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';
import { IModeloTransporte } from '../model/modelo_transporte.model';

@Injectable()
export class ModeloTransporteService extends EntityService<IModeloTransporte> {
  constructor(protected configService: ConfigService) {
    super(
      {
        baseEntityEndPoint: 'modelo_veiculo',
        urlBackend: configService.backendURL
      }
    );
  }
}
